<mat-card appearance="outlined" class="mat-elevation-z4" [class.editing]="isEdit">
    @if (recordId()) {
        <mat-card-header>
            <mat-card-title>{{ formGroup.value.displayName }}</mat-card-title>
        </mat-card-header>
    }
    <mat-card-content class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <h4>{{ 'General.General' | translate }}</h4>
                <form [formGroup]="formGroup" class="form-horizontal">
                    <div class="row">
                        <div class="col-md-12">
                            <sl-auto-complete
                                placeholderKey="General.Type"
                                [control]="formGroup.controls['shareholderTypeId']"
                                [observable]="metaResource.getShareholderTypes()"
                                (clear)="clearShareholderType()"
                                (select)="selectShareholderType($event)" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <sl-auto-complete
                                placeholderKey="Shareholders.OwnershipType"
                                [control]="formGroup.controls['ownershipTypeId']"
                                [observable]="metaResource.getOwnershipTypes()" />
                        </div>
                    </div>
                    <sl-input type="text" placeholderKey="Contact.DisplayName" [control]="formGroup.controls['displayName']" />
                </form>
            </div>
            <div class="col-md-6">
                <h4>{{ 'General.Summary' | translate }}</h4>
                <label>Share ABC 123</label>
                <br />
                <label>Voting Rights 123</label>
            </div>
        </div>
        <mat-divider />
        <div class="row">
            <div class="col-lg-12">
                <h4>
                    {{ (isBusiness ? 'Shareholders.CompanyInformation' : 'Shareholders.PersonalInformation') | translate }}
                </h4>
                <form [formGroup]="formGroup" class="form-horizontal">
                    <div class="row">
                        <div class="col-md-6">
                            @if (isBusiness) {
                                <div class="row">
                                    <div class="col-md-6">
                                        <sl-input
                                            type="text"
                                            placeholderKey="Shareholders.CompanyName"
                                            [control]="formGroup.controls['companyName']" />
                                    </div>
                                    <div class="col-md-6">
                                        <sl-auto-complete
                                            placeholderKey="Shareholders.LegalForm"
                                            [control]="formGroup.controls['companyLegalFormId']"
                                            [observable]="metaResource.getCompanyLegalForms()" />
                                    </div>
                                </div>
                            }
                            <div class="row">
                                <div class="col-md-6">
                                    <sl-auto-complete
                                        placeholderKey="Shareholders.ShortSalutation"
                                        [control]="formGroup.controls['shortSalutationId']"
                                        [observable]="metaResource.getSalutations()"
                                        (select)="selectSalutationText($event)" />
                                </div>
                                <div class="col-md-6">
                                    <sl-auto-complete
                                        placeholderKey="Shareholders.SalutationTitle"
                                        [control]="formGroup.controls['salutationTitleId']"
                                        [observable]="metaResource.getSalutationTitles()"
                                        (select)="selectSalutationTitleText($event)" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <sl-input type="text" placeholderKey="Contact.FirstName" [control]="formGroup.controls['firstName']" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <sl-input type="text" placeholderKey="Contact.LastName" [control]="formGroup.controls['lastName']" />
                                </div>
                                <div class="col-md-3">
                                    <sl-input
                                        type="text"
                                        placeholderKey="Contact.LastNameSupplement"
                                        [control]="formGroup.controls['lastNameSupplement']"
                                        (input)="updateLastNameSuppl($event.target.value)" />
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox [formControl]="formGroup.controls['hasHyphen'] | formControl">
                                        {{ 'Contact.HasHyphen' | translate }}
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            @if (isBusiness) {
                                <div class="row">
                                    <div class="col-md-6">
                                        <sl-auto-complete
                                            placeholderKey="Shareholders.CompanyActivity"
                                            [control]="formGroup.controls['companyActivityId']"
                                            [observable]="metaResource.getCompanyActivities()" />
                                    </div>
                                </div>
                            }
                            <div class="row">
                                <div class="col-md-6">
                                    <sl-datepicker
                                        [control]="formGroup.controls['dateOfBirth']"
                                        [placeholderKey]="isBusiness ? 'Shareholders.FoundedIn' : 'General.DateOfBirth'" />
                                </div>
                            </div>
                            <div class="row">
                                @if (isBusiness) {
                                    <div class="col-md-6">
                                        <sl-input
                                            type="text"
                                            placeholderKey="Shareholders.CompanyDepartament"
                                            [control]="formGroup.controls['companyDepartment']" />
                                    </div>
                                    <div class="col-md-6">
                                        <mat-checkbox [formControl]="formGroup.controls['isManagementOrBoardOfDirectors'] | formControl">
                                            {{ 'Shareholders.IsManagementOrBoardOfDirectors' | translate }}
                                        </mat-checkbox>
                                    </div>
                                } @else {
                                    <div class="col-md-5">
                                        <sl-input
                                            type="text"
                                            placeholderKey="Shareholders.JobTitle"
                                            [control]="formGroup.controls['jobTitle']" />
                                    </div>
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-md-5">
                                                <mat-checkbox [formControl]="formGroup.controls['isEmployee'] | formControl">
                                                    {{ 'Shareholders.IsEmployee' | translate }}
                                                </mat-checkbox>
                                            </div>
                                            <div class="col-md-7">
                                                <mat-checkbox
                                                    [formControl]="formGroup.controls['isManagementOrBoardOfDirectors'] | formControl">
                                                    {{ 'Shareholders.IsManagementOrBoardOfDirectors' | translate }}
                                                </mat-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <sl-auto-complete
                                        placeholderKey="Contact.Nationality"
                                        [control]="formGroup.controls['nationalityCountryId']"
                                        [observable]="getCountries()" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <mat-divider />
        <div class="row">
            <div class="col-lg-12">
                <h4>{{ 'Address.Title' | translate }}</h4>
                <div class="row">
                    <div class="col-md-6">
                        <sl-address [(address)]="address" [formGroup]="formGroup" (anyFieldBlur)="updateFormattedAddress()" />
                        <div class="row">
                            <div class="col-md-12">
                                <span class="formatted-address">{{ formattedAddress }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <form [formGroup]="formGroup" class="form-horizontal">
                            <div class="row">
                                <div class="col-md-12">
                                    <sl-auto-complete
                                        placeholderKey="General.Language"
                                        [control]="formGroup.controls['languageId']"
                                        [observable]="metaResource.getLanguages()" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <sl-auto-complete
                                        placeholderKey="Shareholders.DeliveryMethod"
                                        [control]="formGroup.controls['deliveryMethodId']"
                                        [observable]="metaResource.getDeliveryMethods()" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <sl-auto-complete
                                        placeholderKey="Shareholders.LetterSalutation"
                                        [control]="formGroup.controls['letterSalutationId']"
                                        [observable]="metaResource.getLetterSalutations()" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <mat-checkbox [formControl]="formGroup.controls['isConfidential'] | formControl">
                                        {{ 'Shareholders.IsConfidential' | translate }}
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <sl-input type="email" placeholderKey="Contact.Email" [control]="formGroup.controls['email']" />
                                </div>
                                <div class="col-md-4">
                                    <mat-checkbox [formControl]="formGroup.controls['emailConfirmed'] | formControl">
                                        {{ 'General.Confirmed' | translate }}
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <sl-input
                                        type="text"
                                        placeholderKey="Contact.MobileNumber"
                                        [control]="formGroup.controls['mobileNumber']" />
                                </div>
                                <div class="col-md-4">
                                    <mat-checkbox [formControl]="formGroup.controls['mobileNumberConfirmed'] | formControl">
                                        {{ 'General.Confirmed' | translate }}
                                    </mat-checkbox>
                                </div>
                            </div>
                            @if (!isBusiness) {
                                <div class="row">
                                    <div class="col-md-12">
                                        <mat-form-field>
                                            <mat-select
                                                placeholder="{{ 'Contact.Infomaterial' | translate }}"
                                                [formControl]="infomaterialControl"
                                                (selectionChange)="infomaterialChange($event)"
                                                multiple>
                                                <mat-select-trigger>
                                                    {{ infomaterialControl.value ? infomaterialControl.value[0] : '' }}
                                                    @if (infomaterialControl.value?.length > 1) {
                                                        <span>
                                                            (+{{ infomaterialControl.value.length - 1 }}
                                                            {{
                                                                (infomaterialControl.value?.length === 2
                                                                    ? 'General.Other'
                                                                    : 'General.Others'
                                                                ) | translate
                                                            }})
                                                        </span>
                                                    }
                                                </mat-select-trigger>
                                                @for (im of infomaterials; track im.id) {
                                                    <mat-option [value]="im.label" [id]="im.id">
                                                        {{ im.label }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            }
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
